import { styled as t } from "styled-components";
import { MediaQuery as o } from "../../../../styles/variables.js";
import { CommentActions as n } from "../CommentActions/index.js";
import { Small as i, Caption as a } from "../../../../styles/typography/index.js";
import { CommentAvatar as r } from "../CommentAvatar/index.js";
import { CommentBadge as m } from "../CommentBadge/index.js";
import { defaultCardSpacing as d, createFocusAnimation as p } from "../../style.js";
import { Text as s } from "../CommentContentRenderer/style.js";
import { Theme as e } from "../../../../styles/themes/index.js";
import { CommentActionsWithReactions as c } from "../CommentActionsWithReactions/index.js";
t.span`
  grid-area: bottom;
  ${i}
  line-height: 16px;
  color: rgb(${e.colors.Golf});

  @media ${o.SCREEN_MD_UP} {
    ${a};
  }
`;
const w = t(n)`
  grid-area: bottom;
  justify-content: flex-end;
  @media ${o.SCREEN_MD_UP} {
    padding: 0 8px;
    justify-content: flex-start;
  }
`, E = t(
  c
)`
  grid-area: bottom;

  @media ${o.SCREEN_MD_UP} {
    padding: 0 8px;
  }
`, v = t(r)`
  margin-right: 4px;
`, A = t(m)`
  grid-area: badge;
`, g = t.div`
  display: grid;
  row-gap: 8px;
  width: 100%;
  height: auto;
  grid-template-columns: auto 1fr auto;
  opacity: var(--container-opacity);
  grid-template-areas:
    '. badge'
    'avatar content'
    '. bottom';

  ${d}

  &[data-focused='true'] {
    animation: ${p(e.colors.Charlie)} 4s linear;
  }
`, _ = t(g)``, R = t.div`
  span {
    margin-right: 12px;

    @media ${o.SCREEN_SM} {
      :first-of-type {
        display: none;
      }
    }
  }
`, V = t(s)`
  span {
    margin: 4px;
  }
`, k = t.div`
  grid-area: content;
  background-color: rgba(${e.colors.Hotel});
  padding: 8px;
  border-radius: 8px;
`;
export {
  w as CommentActionsOnView,
  E as CommentActionsWithReactionsOnView,
  v as CommentAvatarOnView,
  A as CommentBadgeOnView,
  R as CommentButtonSkeleton,
  g as CommentViewContainer,
  _ as ContentViewSkeleton,
  k as SkeletonContent,
  V as SkeletonTextContainer
};
